// extracted by mini-css-extract-plugin
export default {"tupacGrid":"co-z","tupacHeader":"do-z","tupacHeader2":"eo-z","tupacMenu":"fo-z","tupacMenu2":"go-z","tupacMain":"ho-z","tupacMain2":"io-z"};